import { render, staticRenderFns } from "./Deptjx.vue?vue&type=template&id=43b49164&scoped=true"
import script from "./Deptjx.vue?vue&type=script&lang=js"
export * from "./Deptjx.vue?vue&type=script&lang=js"
import style0 from "./Deptjx.vue?vue&type=style&index=0&id=43b49164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b49164",
  null
  
)

export default component.exports